import * as React from "react";
import { selectBalancingCoopNewsCharAmount } from "../../balancingSelectors/selectBalancingConstants";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { ButtonPrimaryMedium } from "../generic/common/ButtonPrimaryMedium";
import { TextArea } from "../generic/text-area/TextArea";
import { TextLoca } from "../generic/text/TextLoca";
export var MessageBoardEdit = function (_a) {
    var message = _a.message, handleSave = _a.handleSave, setMessage = _a.setMessage;
    var messagePlaceholder = utilLoca.get(IdLoca.enterCoopNotice_input_web);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextArea, { placeholder: messagePlaceholder, value: message, onChange: function (value) { return setMessage(value); }, maxLength: selectBalancingCoopNewsCharAmount() }),
        React.createElement("div", { className: "flex__align-end padding--small" },
            React.createElement(ButtonPrimaryMedium, { onClick: handleSave },
                React.createElement(TextLoca, { id: IdLoca.save, className: IdStyles.TextButtonDefault })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/MessageBoardEdit.tsx
// module id = 2620
// module chunks = 3